import { api } from './base';

import { MutationArg } from 'v2/types';
import { PartnerSpotlightModel } from 'v2/types/PartnerSpotlightModel';
import { SWRKeyValue } from 'v2/types/swr';

/** PUT body: same as model fields except id/place; `isActive` is optional (toggle on card stays primary UX). */
export type PartnerSpotlightPayload = Omit<PartnerSpotlightModel, 'id' | 'place'>;

export const partnerSpotlightService = {
  getPartnerSpotlights(): Promise<PartnerSpotlightModel[]> {
    return api.get('v1/admin/partner-spotlight').json();
  },

  createPartnerSpotlight(_key: string, { arg }: MutationArg<PartnerSpotlightPayload>): Promise<PartnerSpotlightModel> {
    return api.post('v1/admin/partner-spotlight', { json: arg }).json();
  },

  updatePartnerSpotlight(
    [_key, partnerSpotlightId]: SWRKeyValue,
    { arg }: MutationArg<PartnerSpotlightPayload>
  ): Promise<PartnerSpotlightModel> {
    return api.put(`v1/admin/partner-spotlight/${partnerSpotlightId}`, { json: arg }).json();
  },

  deletePartnerSpotlight([_key, partnerSpotlightId]: SWRKeyValue): Promise<void> {
    return api.delete(`v1/admin/partner-spotlight/${partnerSpotlightId}`).json();
  },

  togglePartnerSpotlightActive(
    [_key, partnerSpotlightId]: SWRKeyValue,
    { arg: isActive }: MutationArg<boolean>
  ): Promise<PartnerSpotlightModel> {
    return api.patch(`v1/admin/partner-spotlight/${partnerSpotlightId}/active`, { json: { isActive } }).json();
  },

  updatePartnerSpotlightStatus(
    [_key, partnerSpotlightId]: SWRKeyValue,
    { arg: status }: MutationArg<PartnerSpotlightModel['status']>
  ): Promise<PartnerSpotlightModel> {
    return api.patch(`v1/admin/partner-spotlight/${partnerSpotlightId}/status`, { json: { status } }).json();
  },

  changePartnerSpotlightsOrder(
    _key: string,
    {
      arg,
    }: MutationArg<{
      status: PartnerSpotlightModel['status'];
      places: Pick<PartnerSpotlightModel, 'id' | 'place'>[];
    }>
  ): Promise<PartnerSpotlightModel[]> {
    return api.patch('v1/admin/partner-spotlight/places', { json: arg }).json();
  },
};
